import type { FunctionComponent } from 'react';

type FormButtonsProps = {
  onSave: () => void;
  onCancel: () => void;
  disabled: boolean;
};

const FormButtons: FunctionComponent<FormButtonsProps> = ({
  onSave = () => null,
  onCancel = () => null,
  disabled = false,
}) => (
  <div className="buttonContainer">
    <button type="button" className="save-button" onClick={() => onSave()} disabled={disabled}>
      save
    </button>
    <button type="button" className="cancel-button" onClick={() => onCancel()}>
      cancel
    </button>
  </div>
);

export default FormButtons;
